import { render, staticRenderFns } from "./IdentityGeneral.vue?vue&type=template&id=152a4444&"
import script from "./IdentityGeneral.vue?vue&type=script&lang=js&"
export * from "./IdentityGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports